const products = [
    {
        "id": 1,
        "site": "AMAZON",
        "link": "https://amzn.to/4pRZ7t7",
        "photo": "https://m.media-amazon.com/images/I/61GGAH5wo+L._SL1500_.jpg",
        "name": "CeraVe Cream",
        "notes": "Post care cream and good for dry skin",
        "skin_types": [
            "dry"
        ]
    },{
        "id": 2,
        "site": "AMAZON",
        "link": "https://amzn.to/49wwbks",
        "photo": "https://m.media-amazon.com/images/I/51A52ReAuLL._SL1000_.jpg",
        "name": "CeraVe Lotion",
        "notes": "Post care lotion good for all skin",
        "skin_types": [
            "all"
        ]
    },{
        "id": 3,
        "site": "AMAZON",
        "link": "https://amzn.to/3YAdrKE",
        "photo": "https://m.media-amazon.com/images/I/61N3ef1RFoL._SL1500_.jpg",
        "name": "Thayers Cucumber",
        "notes": "Refreshing facial toner",
        "categories": [
            "acne"
        ]
    },{
        "id": 4,
        "site": "AMAZON",
        "link": "https://amzn.to/3MUWCYu",
        "photo": "https://m.media-amazon.com/images/I/61wkQbHSoHL._SL1500_.jpg",
        "name": "Thayers Rose Petal",
        "notes": "Soothing facial toner"
    },{
        "id": 5,
        "site": "IMAGE",
        "amazonlink": "https://amzn.to/44PZYlH",
        "link": "https://imageskincare.com/products/vital-c-hydrating-anti-aging-serum-retail",
        "photo": "https://m.media-amazon.com/images/I/51il3PvQfPL._SL1500_.jpg",
        "name": "Image Vital C",
        "notes": "Anti-aging serum",
        "categories": [
            "aging"
        ],
        "skin_types": [
            "all"
        ]
    },{
        "id": 6,
        "site": "IMAGE",
        "amazonlink": "https://amzn.to/4jiFEiD",
        "link": "https://imageskincare.com/products/hydrating-repair-cr-me",
        "photo": "https://m.media-amazon.com/images/I/51Bfsh7I2nL._SL1500_.jpg",
        "name": "Image Vital C Cream",
        "notes": "Deep hydration for all skin types",
        "categories": [
            "aging"
        ],
        "skin_types": [
            "dry"
        ]
    },{
        "id": 7,
        "site": "IMAGE",
        "amazonlink": "https://amzn.to/4f0dysj",
        "link": "https://imageskincare.com/products/clear-cell-salicylic-gel-cleanser",
        "photo": "https://m.media-amazon.com/images/I/41Ob1n2fTfL._SL1400_.jpg",
        "name": "Image Clear Cell Cleanser",
        "notes": "Salicylic acid cleanser, good for acne prone skin",
        "categories": [
            "acne"
        ]
    },{
        "id": 8,
        "site": "IMAGE",
        "amazonlink": "https://amzn.to/4qoIuFc",
        "link": "https://imageskincare.com/products/clear-cell-salicylic-clarifying-pads-2",
        "photo" : "https://m.media-amazon.com/images/I/512o+uHrAcL._SL1500_.jpg",
        "name": "Image Clear Cell Pads",
        "notes": "Medicated clarifying facial pads for acne prone skin",
        "categories": [
            "acne"
        ]
    },{
        "id": 9,
        "site": "IMAGE",
        "amazonlink": "https://amzn.to/4pW3D9P",
        "link": "https://imageskincare.com/products/the-max-creme-1-7-oz",
        "photo" : "https://m.media-amazon.com/images/I/51MauXrlToL._SL1500_.jpg",
        "name": "Image Max Crème",
        "notes": "Peptide cream for all skin types"
    },{
        "id": 10,
        "site": "IMAGE",
        "amazonlink": "https://amzn.to/3YMmg46",
        "link": "https://imageskincare.com/products/stem-cell-eye-creme-with-vectorize-technology-1",
        "photo": "https://m.media-amazon.com/images/I/512Ed6Z5LTL._SL1500_.jpg",
        "name": "Image Max Eye Crème",
        "notes": "Peptide and plant cell extracts. For firmness, dark circles, and puffiness"
    },{
        "id": 11,
        "site": "IMAGE",
        "amazonlink": "https://amzn.to/4b8w4Ng",
        "link": "https://imageskincare.com/products/stem-cell-serum-with-vectorize-technology",
        "photo": "https://m.media-amazon.com/images/I/5155-DFnnJL._SL1500_.jpg",
        "name": "Image Max Serum",
        "notes": "Multi Peptide serum for all skin types"
    },{
    //     "id": 12,
    //     "site": "AMAZON",
    //     "link": "https://amzn.to/4qyXJM4",
    //     "photo": "https://m.media-amazon.com/images/I/51pDKS3P5VL._SL1500_.jpg",
    //     "name": "Iluma Intense Brightening Powder",
    //     "notes": "Gently removes dead skin cells and smooths skin"
    // },{ // OUT OF STOCK
        "id": 13,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/image-md-restoring-power-c-serum",
        "photo": "https://imageskincare.com/cdn/shop/files/mainretail.webp?v=1756902156",
        "name": "Image MD Power-C Serum",
        "notes": "Reduces aging and pigmentation, light weight formula"
    },{
        "id": 14,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/image-md-restoring-eye-masks",
        "amazonlink": "https://amzn.to/3KPh1O4",
        "photo": "https://m.media-amazon.com/images/I/51z+3Q7uq7L._SL1500_.jpg",
        "name": "Image MD Eye Masks",
        "notes": "Cool, hydrating eye pads with caffeine, aloe vera, and triple hyaluronic acids"
    },{
        "id": 15,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/ormedic-balancing-biopeptide-creme-1",
        "amazonlink": "https://amzn.to/49BU2yn",
        "photo": "https://m.media-amazon.com/images/I/61vL+KcJDxL._SL1500_.jpg",
        "name": "Image Ormedic Biopeptide Crème",
        "notes": "Nourishing, plant-based skin cream with organic ingredients"
    },{
        "id": 16,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/ormedic-lip-enhancement-complex",
        "amazonlink": "https://amzn.to/3MUWIPP",
        "photo": "https://m.media-amazon.com/images/I/51dsJLejHML._SL1500_.jpg",
        "name": "Image Ormedic Lip Balm",
        "notes": "Skin care for your lips with avocado oil and vitamin E"
    },{
        "id": 17,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/iluma-intense-brightening-exfoliating-cleanser",
        "amazonlink": "https://amzn.to/4pc4jad",
        "photo": "https://m.media-amazon.com/images/I/51GISXGXLBL._SL1500_.jpg",
        "name": "Iluma Brightening Cleanser",
        "notes": "Intense brightening and exfoliating cleanser for dryness and discoloration"
    },{
        "id": 18,
        "site": "AMAZON",
        "link": "https://amzn.to/3Liexrz",
        "photo": "https://m.media-amazon.com/images/I/51-oqiFxx3L._SL1488_.jpg",
        "name": "Avène Cicalifate",
        "notes": "Intensive post care cream"
    },{
        "id": 19,
        "site": "AMAZON",
        "link": "https://amzn.to/4qvb1Jp",
        "photo": "https://m.media-amazon.com/images/I/51Y1hphu3wL._SL1500_.jpg",
        "name": "Avène Cicalifate Restore",
        "notes": "Calming, occlusive protective cream. Help restore skin barrier 4x faster"
    },{
        "id": 20,
        "site": "AMAZON",
        "link": "https://amzn.to/3Lfy8Zj",
        "photo": "https://m.media-amazon.com/images/I/515z4hCXOVL._SL1500_.jpg",
        "name": "Avene Retrinal",
        "notes": "Helps reduce wrinkles without irritating skin. Intensive multi-corrective cream",
        "categories": [
            "acne"
        ]
    },{
        "id": 21,
        "site": "AMAZON",
        "link": "https://amzn.to/4rZTfyZ",
        "photo": "https://m.media-amazon.com/images/I/61grCakOcPL._SL1500_.jpg",
        "name": "Avene Retrinal Eyes",
        "notes": "Reduce under eye lines, puffiness, and dark circles.",
    },{
        "id": 22,
        "site": "AMAZON",
        "link": "https://amzn.to/44Qyg8h",
        "photo": "https://m.media-amazon.com/images/I/719sa5BGhJL._AC_SL1500_.jpg",
        "name": "Finishing Touch Flawless",
        "notes": "Facial hair remover great for peach fuzz",
        "categories": [
            "recommended",
        ]
    },{
        "id": 23,
        "site": "AMAZON",
        "link": "https://amzn.to/4qe8DXA",
        "photo": "https://m.media-amazon.com/images/I/61bUOGxX7HL._SL1500_.jpg",
        "name": "Ulike LED Therapy Mask",
        "notes": "4 modes with Blue, Red, Yellow and Infrared lights",
        "categories": [
            "recommended",
        ]
    },
    {
        "id": 24,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/ageless-pure-hyaluronic-filler",
        "amazonlink": "https://amzn.to/4pOpxuY",
        "photo": "https://m.media-amazon.com/images/I/5198dawf-zL._SL1500_.jpg",
        "name": "Hyaluronic Acid",
        "notes": "Smooth wrinkles and soften fine lines",
        "categories": [
            "recommended",
            "aging"
        ]
    },{
        "id": 25,
        "site": "AMAZON",
        "link": "https://amzn.to/4m5PZjt",
        "photo": "https://m.media-amazon.com/images/I/712TRcOLyeL._AC_SL1500_.jpg",
        "name": "Red Light Cupping Device",
        "notes": "Red light therapy with suction for anti-aging and skin rejuvenation"
    },{
        "id": 26,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/image-md-biotech-longevity-creme",
        "photo": "https://imageskincare.com/cdn/shop/files/01_PDP_MDbiotechlongevitycreme_Retail_Product.jpg",
        "name": "IMAGE MD Biotech Longevity Crème",
        "notes": "Firm, hydrate, and improve elasticity",
        "categories": [
            "new"
        ]
    },{
        "id": 27,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/daily-prevention-pure-mineral-hydrating-moisturizer-spf-30",
        "photo": "https://imageskincare.com/cdn/shop/files/DP_hydrating_SPF_30_retail.webp",
        "name": "IMAGE SPF Hydrating Moisturizer",
        "notes": "Daily prevention moisturizer with SPF 30",
        "categories": [
            "new"
        ]
    },{
        "id": 28,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/image-md-restoring-eye-recovery-gel-1",
        "photo": "https://imageskincare.com/cdn/shop/products/IMAGE_MD_restoring_recovery_eye_gel_PDP_R01a.jpg",
        "name": "IMAGE MD Restoring Eye Recovery Gel",
        "notes": "Reduce fine lines, wrinkles, puffiness, and dark circles",
        "categories": [
            "new"
        ]
    },
    {
        "id": 29,
        "site": "IMAGE",
        "link": "https://imageskincare.com/products/image-md-restoring-youth-serum-1",
        "photo": "https://imageskincare.com/cdn/shop/products/IMAGE_MD_restoring_youth_serum_PDP_R01a.jpg",
        "name": "IMAGE MD Restoring Youth Serum",
        "notes": "Multi-peptide serum to help reduce wrinkles and improve skin texture",
        "categories": [
            "new"
        ]
    },
    {
        "id": 30,
        "site": "PLATINUM_SKINCARE",
        "link": "https://www.platinumskincare.com/fade-bright-lightening/",
        "photo": "https://cdn11.bigcommerce.com/s-ake4mh/images/stencil/1280x1280/products/234/1929/BBB_Fadebright_2oz_white__42498.1769103104.jpg?c=2",
        "name": "Fade Bright",
        "notes": "Fast Acting Pigment Inhibitor. Helps reduce the appearance of dark spots, hyperpigmentation, and uneven skin tone.",
        "categories": [
            "new"
        ]
    },
    {
        "id": 31,
        "site": "AMAZON",
        "link": "https://link.amazon/B04HBl7Sp",
        "photo": "https://m.media-amazon.com/images/I/713Ca5aXpyL._SL1500_.jpg",
        "name": "Cicaplast Balm B5+",
        "notes": "Multi-Purpose Skin healing cream with centella asiatica, shea butter & panthenol.",
        "categories": [
            "new"
        ]
    }
]

export default products;